<template>
  <div class="cmp-distribution-report-container">
    <v-card v-for="report in reportData.data" :key="report.id" class="card">
      <h2>{{ report.chapter }}</h2>
      <div class="card-content">
        <table class="table" border="1">
          <thead>
            <tr>
              <th class="cell">{{reportData.group_by}}</th>
              <th v-if="reportData.physical == 1" colspan="3">
                <div class="header-wrapper">
                  <div class="header-title">{{$t('net_sales_physical')}}</div>
                  <div class="title-wrapper">
                    <span class="sub-head">{{ $t('unit') }}</span
                    ><span class="sub-head">{{ $t('turn_over') }}</span
                    ><span class="sub-head">∅</span>
                  </div>
                </div>
              </th>
              <th v-if="reportData.bundle_dl == 1" colspan="3">
                <div class="header-wrapper">
                  <div class="header-title">{{ $t('bundle_downloads') }}</div>
                  <div class="title-wrapper">
                    <span class="sub-head">{{ $t('unit') }}</span
                    ><span class="sub-head">{{ $t('turn_over') }}</span
                    ><span class="sub-head">∅</span>
                  </div>
                </div>
              </th>
              <th v-if="reportData.bundle_str == 1" colspan="3">
                <div class="header-wrapper">
                  <div class="header-title">{{ $t('bundle_streams') }}</div>
                  <div class="title-wrapper">
                    <span class="sub-head">{{ $t('unit') }}</span
                    ><span class="sub-head">{{ $t('turn_over') }}</span
                    ><span class="sub-head">∅</span>
                  </div>
                </div>
              </th>
              <th v-if="reportData.bundle_other == 1" colspan="3">
                <div class="header-wrapper">
                  <div class="header-title">{{ $t('bundle_others') }}</div>
                  <div class="title-wrapper">
                    <span class="sub-head">{{ $t('unit') }}</span
                    ><span class="sub-head">{{ $t('turn_over') }}</span
                    ><span class="sub-head">∅</span>
                  </div>
                </div>
              </th>
              <th v-if="reportData.track_dl == 1" colspan="3">
                <div class="header-wrapper">
                  <div class="header-title">{{ $t('track_downloads') }}</div>
                  <div class="title-wrapper">
                    <span class="sub-head">{{ $t('unit') }}</span
                    ><span class="sub-head">{{ $t('turn_over') }}</span
                    ><span class="sub-head">∅</span>
                  </div>
                </div>
              </th>
              <th v-if="reportData.track_str == 1" colspan="3">
                <div class="header-wrapper">
                  <div class="header-title">{{ $t('track_streams') }}</div>
                  <div class="title-wrapper">
                    <span class="sub-head">{{ $t('unit') }}</span
                    ><span class="sub-head">{{ $t('turn_over') }}</span
                    ><span class="sub-head">∅</span>
                  </div>
                </div>
              </th>
              <th v-if="reportData.track_other == 1" colspan="3">
                <div class="header-wrapper">
                  <div class="header-title">{{ $t('track_others') }}</div>
                  <div class="title-wrapper">
                    <span class="sub-head">{{ $t('unit') }}</span
                    ><span class="sub-head">{{ $t('turn_over') }}</span
                    ><span class="sub-head">∅</span>
                  </div>
                </div>
              </th>

              <th v-if="reportData.thirdparty == 1" class="cell">
                {{ $t('turnover_thirdparty') }}
              </th>
              <th v-if="reportData.performance == 1" class="cell">
                {{ $t('turnover_performance') }}
              </th>
              <th class="cell">{{ $t('total_turnover') }}</th>
            </tr>
          </thead>

          <tbody>
            <tr v-for="item in report.data" :key="item.id">
              <td
                :title="item.group_name"
                class="cell"
                style="font-weight: 500"
              >
                {{ item.group_name }}
              </td>
              <td
                class="cell-num"
                :title="item.data.physical_units"
                v-if="reportData.physical == 1"
              >
                {{
                  item.data.physical_units
                    ? $dft.curr(item.data.physical_units)
                    : item.data.physical_units
                }}
              </td>
              <td
                class="cell-num"
                :title="item.data.physical_turnover"
                v-if="reportData.physical == 1"
              >
                {{
                  item.data.physical_turnover
                    ? $dft.curr(item.data.physical_turnover)
                    : item.data.physical_turnover
                }}
              </td>
              <td
                class="cell-num"
                :title="item.data.physical_avg"
                v-if="reportData.physical == 1"
              >
                {{
                  item.data.physical_avg
                    ? $dft.curr(item.data.physical_avg)
                    : item.data.physical_avg
                }}
              </td>

              <td
                class="cell-num"
                :title="item.data.bundle_dl_units"
                v-if="reportData.bundle_dl == 1"
              >
                {{
                  item.data.bundle_dl_units
                    ? $dft.curr(item.data.bundle_dl_units)
                    : item.data.bundle_dl_units
                }}
              </td>
              <td
                class="cell-num"
                :title="item.data.bundle_dl_turnover"
                v-if="reportData.bundle_dl == 1"
              >
                {{
                  item.data.bundle_dl_turnover
                    ? $dft.curr(item.data.bundle_dl_turnover)
                    : item.data.bundle_dl_turnover
                }}
              </td>
              <td
                class="cell-num"
                :title="item.data.bundle_dl_avg"
                v-if="reportData.bundle_dl == 1"
              >
                {{
                  item.data.bundle_dl_avg
                    ? $dft.curr(item.data.bundle_dl_avg)
                    : item.data.bundle_dl_avg
                }}
              </td>

              <td
                class="cell-num"
                :title="item.data.bundle_str_units"
                v-if="reportData.bundle_str == 1"
              >
                {{
                  item.data.bundle_str_units
                    ? $dft.curr(item.data.bundle_str_units)
                    : item.data.bundle_str_units
                }}
              </td>
              <td
                class="cell-num"
                :title="item.data.bundle_str_turnover"
                v-if="reportData.bundle_str == 1"
              >
                {{
                  item.data.bundle_str_turnover
                    ? $dft.curr(item.data.bundle_str_turnover)
                    : item.data.bundle_str_turnover
                }}
              </td>
              <td
                class="cell-num"
                :title="item.data.bundle_str_avg"
                v-if="reportData.bundle_str == 1"
              >
                {{
                  item.data.bundle_str_avg
                    ? $dft.curr(item.data.bundle_str_avg)
                    : item.data.bundle_str_avg
                }}
              </td>

              <td
                class="cell-num"
                :title="item.data.bundle_other_units"
                v-if="reportData.bundle_other == 1"
              >
                {{
                  item.data.bundle_other_units
                    ? $dft.curr(item.data.bundle_other_units)
                    : item.data.bundle_other_units
                }}
              </td>
              <td
                class="cell-num"
                :title="item.data.bundle_other_turnover"
                v-if="reportData.bundle_other == 1"
              >
                {{
                  item.data.bundle_other_turnover
                    ? $dft.curr(item.data.bundle_other_turnover)
                    : item.data.bundle_other_turnover
                }}
              </td>
              <td
                class="cell-num"
                :title="item.data.bundle_other_avg"
                v-if="reportData.bundle_other == 1"
              >
                {{
                  item.data.bundle_other_avg
                    ? $dft.curr(item.data.bundle_other_avg)
                    : item.data.bundle_other_avg
                }}
              </td>

              <td
                class="cell-num"
                :title="item.data.track_dl_units"
                v-if="reportData.track_dl == 1"
              >
                {{
                  item.data.track_dl_units
                    ? $dft.curr(item.data.track_dl_units)
                    : item.data.track_dl_units
                }}
              </td>
              <td
                class="cell-num"
                :title="item.data.track_dl_turnover"
                v-if="reportData.track_dl == 1"
              >
                {{
                  item.data.track_dl_turnover
                    ? $dft.curr(item.data.track_dl_turnover)
                    : item.data.track_dl_turnover
                }}
              </td>
              <td
                class="cell-num"
                :title="item.data.track_dl_avg"
                v-if="reportData.track_dl == 1"
              >
                {{
                  item.data.track_dl_avg
                    ? $dft.curr(item.data.track_dl_avg)
                    : item.data.track_dl_avg
                }}
              </td>

              <td
                class="cell-num"
                :title="item.data.track_str_units"
                v-if="reportData.track_str == 1"
              >
                {{
                  item.data.track_str_units
                    ? $dft.curr(item.data.track_str_units)
                    : item.data.track_str_units
                }}
              </td>
              <td
                class="cell-num"
                :title="item.data.track_str_turnover"
                v-if="reportData.track_str == 1"
              >
                {{
                  item.data.track_str_turnover
                    ? $dft.curr(item.data.track_str_turnover)
                    : item.data.track_str_turnover
                }}
              </td>
              <td
                class="cell-num"
                :title="item.data.track_str_avg"
                v-if="reportData.track_str == 1"
              >
                {{
                  item.data.track_str_avg
                    ? $dft.curr(item.data.track_str_avg)
                    : item.data.track_str_avg
                }}
              </td>

              <td
                class="cell-num"
                :title="item.data.track_other_units"
                v-if="reportData.track_other == 1"
              >
                {{
                  item.data.track_other_units
                    ? $dft.curr(item.data.track_other_units)
                    : item.data.track_other_units
                }}
              </td>
              <td
                class="cell-num"
                :title="item.data.track_other_turnover"
                v-if="reportData.track_other == 1"
              >
                {{
                  item.data.track_other_turnover
                    ? $dft.curr(item.data.track_other_turnover)
                    : item.data.track_other_turnover
                }}
              </td>
              <td
                class="cell-num"
                :title="item.data.track_other_avg"
                v-if="reportData.track_other == 1"
              >
                {{
                  item.data.track_other_avg
                    ? $dft.curr(item.data.track_other_avg)
                    : item.data.track_other_avg
                }}
              </td>

              <td
                class="cell cell-num"
                :title="item.data.thirdparty_turnover"
                v-if="reportData.thirdparty == 1"
              >
                {{
                  item.data.thirdparty_turnover
                    ? $dft.curr(item.data.thirdparty_turnover)
                    : item.data.thirdparty_turnover
                }}
              </td>
              <td
                :title="item.data.performance_turnover"
                v-if="reportData.performance == 1"
                class="cell cell-num"
              >
                {{
                  item.data.performance_turnover
                    ? $dft.curr(item.data.performance_turnover)
                    : item.data.performance_turnover
                }}
              </td>
              <td :title="item.data.turnover" class="cell cell-num">
                {{
                  item.data.turnover
                    ? $dft.curr(item.data.turnover)
                    : item.data.turnover
                }}
              </td>
            </tr>
            <tr>
              <td class="cell" style="font-weight: 500">Total</td>
              <td
                class="cell-num"
                :title="report.sum.total_physical_units"
                v-if="reportData.physical == 1"
              >
                {{
                  report.sum.total_physical_units
                    ? $dft.curr(report.sum.total_physical_units)
                    : report.sum.total_physical_units
                }}
              </td>
              <td
                class="cell-num"
                :title="report.sum.total_physical_turnover"
                v-if="reportData.physical == 1"
              >
                {{
                  report.sum.total_physical_turnover
                    ? $dft.curr(report.sum.total_physical_turnover)
                    : report.sum.total_physical_turnover
                }}
              </td>
              <td
                class="cell-num"
                :title="report.sum.total_physical_avg"
                v-if="reportData.physical == 1"
              >
                {{
                  report.sum.total_physical_avg
                    ? $dft.curr(report.sum.total_physical_avg)
                    : report.sum.total_physical_avg
                }}
              </td>

              <td
                class="cell-num"
                :title="report.sum.total_bundle_dl_units"
                v-if="reportData.bundle_dl == 1"
              >
                {{
                  report.sum.total_bundle_dl_units
                    ? $dft.curr(report.sum.total_bundle_dl_units)
                    : report.sum.total_bundle_dl_units
                }}
              </td>
              <td
                class="cell-num"
                :title="report.sum.total_bundle_dl_turnover"
                v-if="reportData.bundle_dl == 1"
              >
                {{
                  report.sum.total_bundle_dl_turnover
                    ? $dft.curr(report.sum.total_bundle_dl_turnover)
                    : report.sum.total_bundle_dl_turnover
                }}
              </td>
              <td
                class="cell-num"
                :title="report.sum.total_bundle_dl_avg"
                v-if="reportData.bundle_dl == 1"
              >
                {{
                  report.sum.total_bundle_dl_avg
                    ? $dft.curr(report.sum.total_bundle_dl_avg)
                    : report.sum.total_bundle_dl_avg
                }}
              </td>

              <td
                class="cell-num"
                :title="report.sum.total_bundle_str_units"
                v-if="reportData.bundle_str == 1"
              >
                {{
                  report.sum.total_bundle_str_units
                    ? $dft.curr(report.sum.total_bundle_str_units)
                    : report.sum.total_bundle_str_units
                }}
              </td>
              <td
                class="cell-num"
                :title="report.sum.total_bundle_str_turnover"
                v-if="reportData.bundle_str == 1"
              >
                {{
                  report.sum.total_bundle_str_turnover
                    ? $dft.curr(report.sum.total_bundle_str_turnover)
                    : report.sum.total_bundle_str_turnover
                }}
              </td>
              <td
                class="cell-num"
                :title="report.sum.total_bundle_str_avg"
                v-if="reportData.bundle_str == 1"
              >
                {{
                  report.sum.total_bundle_str_avg
                    ? $dft.curr(report.sum.total_bundle_str_avg)
                    : report.sum.total_bundle_str_avg
                }}
              </td>

              <td
                class="cell-num"
                :title="report.sum.total_bundle_other_units"
                v-if="reportData.bundle_other == 1"
              >
                {{
                  report.sum.total_bundle_other_units
                    ? $dft.curr(report.sum.total_bundle_other_units)
                    : report.sum.total_bundle_other_units
                }}
              </td>
              <td
                class="cell-num"
                :title="report.sum.total_bundle_other_turnover"
                v-if="reportData.bundle_other == 1"
              >
                {{
                  report.sum.total_bundle_other_turnover
                    ? $dft.curr(report.sum.total_bundle_other_turnover)
                    : report.sum.total_bundle_other_turnover
                }}
              </td>
              <td
                class="cell-num"
                :title="report.sum.total_bundle_other_avg"
                v-if="reportData.bundle_other == 1"
              >
                {{
                  report.sum.total_bundle_other_avg
                    ? $dft.curr(report.sum.total_bundle_other_avg)
                    : report.sum.total_bundle_other_avg
                }}
              </td>

              <td
                class="cell-num"
                :title="report.sum.total_track_dl_units"
                v-if="reportData.track_dl == 1"
              >
                {{
                  report.sum.total_track_dl_units
                    ? $dft.curr(report.sum.total_track_dl_units)
                    : report.sum.total_track_dl_units
                }}
              </td>
              <td
                class="cell-num"
                :title="report.sum.total_track_dl_turnover"
                v-if="reportData.track_dl == 1"
              >
                {{
                  report.sum.total_track_dl_turnover
                    ? $dft.curr(report.sum.total_track_dl_turnover)
                    : report.sum.total_track_dl_turnover
                }}
              </td>
              <td
                class="cell-num"
                :title="report.sum.total_track_dl_avg"
                v-if="reportData.track_dl == 1"
              >
                {{
                  report.sum.total_track_dl_avg
                    ? $dft.curr(report.sum.total_track_dl_avg)
                    : report.sum.total_track_dl_avg
                }}
              </td>

              <td
                class="cell-num"
                :title="report.sum.total_track_str_units"
                v-if="reportData.track_str == 1"
              >
                {{
                  report.sum.total_track_str_units
                    ? $dft.curr(report.sum.total_track_str_units)
                    : report.sum.total_track_str_units
                }}
              </td>
              <td
                class="cell-num"
                :title="report.sum.total_track_str_turnover"
                v-if="reportData.track_str == 1"
              >
                {{
                  report.sum.total_track_str_turnover
                    ? $dft.curr(report.sum.total_track_str_turnover)
                    : report.sum.total_track_str_turnover
                }}
              </td>
              <td
                class="cell-num"
                :title="report.sum.total_track_str_avg"
                v-if="reportData.track_str == 1"
              >
                {{
                  report.sum.total_track_str_avg
                    ? $dft.curr(report.sum.total_track_str_avg)
                    : report.sum.total_track_str_avg
                }}
              </td>

              <td
                class="cell-num"
                :title="report.sum.total_track_other_units"
                v-if="reportData.track_other == 1"
              >
                {{
                  report.sum.total_track_other_units
                    ? $dft.curr(report.sum.total_track_other_units)
                    : report.sum.total_track_other_units
                }}
              </td>
              <td
                class="cell-num"
                :title="report.sum.total_track_other_turnover"
                v-if="reportData.track_other == 1"
              >
                {{
                  report.sum.total_track_other_turnover
                    ? $dft.curr(report.sum.total_track_other_turnover)
                    : report.sum.total_track_other_turnover
                }}
              </td>
              <td
                class="cell-num"
                :title="report.sum.total_track_other_avg"
                v-if="reportData.track_other == 1"
              >
                {{
                  report.sum.total_track_other_avg
                    ? $dft.curr(report.sum.total_track_other_avg)
                    : report.sum.total_track_other_avg
                }}
              </td>

              <td
                class="cell cell-num"
                :title="report.sum.total_thirdparty_turnover"
                v-if="reportData.thirdparty == 1"
              >
                {{
                  report.sum.total_thirdparty_turnover
                    ? $dft.curr(report.sum.total_thirdparty_turnover)
                    : report.sum.total_thirdparty_turnover
                }}
              </td>
              <td
                :title="report.sum.total_performance_turnover"
                v-if="reportData.performance == 1"
                class="cell cell-num"
              >
                {{
                  report.sum.total_performance_turnover
                    ? $dft.curr(report.sum.total_performance_turnover)
                    : report.sum.total_performance_turnover
                }}
              </td>
              <td :title="report.sum.total_turnover" class="cell cell-num">
                {{
                  report.sum.total_turnover
                    ? $dft.curr(report.sum.total_turnover)
                    : report.sum.total_turnover
                }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </v-card>
  </div>
</template>


<script>
import NTable from "@/plugins/datatable/datatable";
import {
  createNTableConfig,
  createTableHeader,
} from "../../../../plugins/datatable";
export default {
  components: { NTable },
  props: ["reportData"],
  mounted: function () {},
  data: function () {
    return {
      tableConfig: createNTableConfig({
        headerStyle: 2,
        rowHeight: 30,
        fullHeight: true,
        footer: false,
      }),
     
    };
  },
  computed: {
    headers: function () {
      return [createTableHeader("name"), createTableHeader("calories")];
    },
  },
  methods: {
    onExport() {},
  },
};
</script>

<style lang="scss" >
.cmp-distribution-report-container {
  display: flex;
  flex-direction: column;
  overflow: auto;
  height: calc(100vh - 180px);
  width: 100%;
  .card {
    display: flex;
    flex-direction: column;
    padding: 2rem;
    box-shadow: none;
    .card-content {
      display: flex;
      flex-direction: column;
      width: 100%;
      height: 100%;
      margin-top: 1rem;
      .header-wrapper {
        display: flex;
        flex-direction: column;
        gap: 0.5rem;
        .header-title {
          border-bottom: 1px solid;
          padding: 0.3rem 0;
        }
        .title-wrapper {
          display: flex;
          align-items: center;
          justify-content: space-around;
          .sub-head {
            //padding: 0 0.3rem;
            //min-width: 50px;
            &:not(:last-child) {
              //border-right: 1px solid #ccc;
            }
          }
        }
      }
      .table thead th {
        padding: 0px;
        color: rgba(0, 0, 0, 0.87);
      }
      .table tbody td {
        padding: 0 0.2rem;
        text-align: left;
        max-width: 45px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        height: 30px;
        &.cell {
          min-width: 100px;
        }
        &.cell-num {
          text-align: right;
        }
      }
      .table thead tr {
        border: none;
      }
      .table tbody tr {
        border: none;
      }
    }
  }
}
</style>